import { Banner } from '@wds/banner';
import React, { useState } from 'react';
import { useSearchParams } from '~app/pages/AppsDirectory/components/utils';

export const NewAppDirectoryBanner = () => {
  const urlParams = useSearchParams();
  const fromV1 = urlParams.get('from_v1');
  const [showFromV1Banner, setShowFromV1Banner] = useState(fromV1);

  return (
    <>
      <If condition={showFromV1Banner}>
        <Banner
          showIcon="true"
          show={showFromV1Banner}
          onClose={() => setShowFromV1Banner(false)}
          dismissible
          color="info"
        >
          The URL you have selected is no longer valid as we have updated our App Directory to provide you a better
          experience. You may continue to filter and search for your desired app or integration. And, don’t forget to
          update any bookmarks you may have.
        </Banner>
      </If>
    </>
  );
};

export default NewAppDirectoryBanner;
